import axios from "axios";
import OperationTypes from "../../../types";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import { CreateDamageFormTypes, DamageFormTypes} from "../Types";
import { Buffer } from "buffer";
import i18n from "i18next";

var qs = require('qs');

const DamageFormService = {
    list: {
        getDamageForm:(tenants:string,data:DamageFormTypes.FilterDamageForm,serverParams: ServerSideTypes.IParams)=>{
            return axios.get<ServerSideTypes.IResult<DamageFormTypes.DamageForm>>("/masterdatadamage/damageform/byfilters",{
                params:{tenants,...data,...serverParams},
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                 },
            }).then(response =>response.data
       )
        },
		getDamageFormCodes:(tenant:string)=>{
            return axios.get<any>("/masterdatadamage/damageform/codes",{params:{tenant:tenant}})
            .then(response =>response.data)
        },
        getRepository:(tenant:string)=>{
            return axios.get<any>('masterdatadamage/repository',{params:{tenant:tenant}}).then
            (response =>response.data)
        },
        getEvent:(tenant:string, fromSearch: string = "")=>{
            return axios.get<any>('masterdatadamage/event',{params:{tenant:tenant, fromSearch:fromSearch}}).then
            (response =>response.data)
        },
        getEventType:(tenant:string)=>{
            return axios.get<any>('masterdatadamage/eventtype',{params:{tenant:tenant}}).then
            (response =>response.data)
        },
        getExport:(tenants:string,data:DamageFormTypes.FilterDamageForm)=>{
            return axios.get<any>("/masterdatadamage/damageform/exportexcel",{
                params:{tenants,...data},
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                 },
                responseType:"arraybuffer"})

        },
        getMobilityStore:(tenant:string)=>{
            return axios.get<any>('masterdatadamage/damageform/getmslist',{params:{tenants:tenant}}).then
            (response =>response.data)
        },
        getVehicleByPlate: (tenant: string, plate: string) => {
            return axios
                .get<OperationTypes.Vehicle>(`masterdatavehicle/vehicle/plate/${plate}`, { params: { tenant: tenant } })
                .then((response) => response.data);
        },
        put:{
            getExportLeasysrent:(tenant:string,data:FormData)=>{
                return axios.put<any>("./masterdatadamage/damageform/excelfromleasysrent",data,{params:{tenant:tenant},responseType:"arraybuffer"}).then(response=>response)
            },
            getExportDrivalia:(tenant:string,data:FormData)=>{
                return axios.put<any>("./masterdatadamage/damageform/excelfrominsurance",data,{params:{tenant:tenant},responseType:"arraybuffer"}).then(response=>response)
            },
            updateBill:(tenant:string,damageFormIds:any)=>{
                return axios.put<any>("./masterdatadamage/damageform/bill",damageFormIds,{params:{tenant:tenant}})
            }
        }
    },
    details: {
        domains: {
            getEventTypes: (tenant: string, fromSearch: boolean) => {
                return axios.get<OperationTypes.Domain[]>("/masterdatadamage/eventtype", { params: { tenant, fromSearch }}).then(
                    (response) => {
                        return response.data;
                    }
                )
            },
            getAttachmentTypes: (tenant: string) => {
                return axios.get<OperationTypes.Domain[]>("/masterdatadamage/attachmenttype", {params: {tenant}}).then(
                    (response) => {
                        return response.data;
                    }
                )
            },
            getDocumentTypes: (tenant : string) => {
                return axios.get<DamageFormTypes.IDocumentTypeRow[]>("/masterdatadamage/documenttype", {params : {tenant}}).then(
                    (response) => {
                        return response.data;
                    }
                )
            },
            getMsListTypes: (tenants: string) => {
                return axios.get<DamageFormTypes.IMobilityStore[]>("/masterdatadamage/damageform/getmslist", {params: {tenants: tenants}}).then(
                    (response) => {
                        return response.data;
                    }
                )
            },
            getRsListTypes: (tenants: string) => {
                return axios.get<DamageFormTypes.IRepairShop[]>("/masterdatadamage/damageform/getrslist", {params: {tenants: tenants}}).then(
                    (response) => {
                        return response.data;
                    }
                )
            }
        },
        messages: {
            get: {
                templateContent: (tenant: string, formProgressive: string, language: string, templateCode: string) => {
                    return axios.get<{
                        eventType: string;
                        language: string;
                        subject?: string;
                        bodyHtml?: string;
                        bodyText?: string;
                        templateName?: string;
                        placeholders?: Record<string, string>;
                    }>("/masterdatadamage/mailtemplate/content", {
                        params: { tenant, currentFormProgressive: formProgressive, formProgressive, language, templateCode }
                    }).then(
                        response => response.data
                    );
                },
                byId: (id: string) => {
                  return axios.get<DamageFormTypes.IMessage[]>("/masterdatadamage/mail/bydamageformid", { params: { damageFormId: id}}).then(
                    (response) => {
                        return response.data
                    }
                   );
                },
                mailTemplates: (tenant: string, formProgressive: string, language: string) => {
                    return axios.get<DamageFormTypes.IMailTemplate[]>("/masterdatadamage/mailtemplate/bytenant", { params: {tenant, formProgressive, language}}).then(
                        response => {
                            return response.data;
                        }
                    )
                },
                mailTemplateById: (templateId: string, formProgressive: string) => {
                    return axios.get<DamageFormTypes.IMailTemplate>("/masterdatadamage/mailtemplate/byid", { params: { templateId, formProgressive }}).then(
                        response => {
                            return response.data;
                        }
                    )
                },
                languages: (tenant: string) => {
                    return axios.get<string[]>("/masterdatadamage/mailtemplate/languages", { params: {tenant}}).then(
                        response => response.data,
                    )
                }
            },
            put: {
                // LPP-24664: salva i destinatari di default persistiti di un template (per templateId univoco).
                templateRecipients: (templateId: number, tenant: string, code: string, language: string, recipients: string[]) => {
                    return axios.put("/masterdatadamage/mailtemplate/recipients", {
                        templateId,
                        tenant,
                        code,
                        language,
                        recipients,
                    }).then(
                        (response) => response.data
                    )
                }
            },
            post: {
                sendMail: (language: string,data: DamageFormTypes.IMessageForm) => {
                    return axios.post("/masterdatadamage/mail/sendmail", {
                        language: language,
                        subject: data.subject,
                        body: data.body,
                        damageFormId: data.damageFormId,
                        to: data.to,
                        templateCode: data.code,
                        attachments: data.attachmentsSelected?.map((attachment) => ({
                            id: attachment.id,
                            type: attachment.type,
                        })),
                        // Mappa unica di tutti i placeholder
                        placeholders: data.placeholders,
                    }).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            }
        },
        generalInfo: {
            get: {
                byId: (damageFormId: string, tenant: string) => {
                    return axios.get<DamageFormTypes.IGeneralInfo>("/masterdatadamage/damageform/byid", { params: { damageFormId, tenant }}).then(
                        (response) => {
                            return response.data
                        }
                    )
                },
                byCode: (formCode: string, tenant: string) => {
                    return axios.get<string>("/masterdatadamage/damageform/idbycode", { params: { formCode, tenant }}).then(
                        (response) => {
                            return response.data
                        }
                    )
                },
                formByCode: (formCode: string, tenant: string) => {
                    return axios.get<DamageFormTypes.FormByCode>("/masterdatadamage/damageform/formbycode", { params: { formCode, tenant }}).then(
                        (response) => {
                            return response.data
                        }
                    )
				}
            },
            put: {
                updateByid: (tenant: string, generalInfo: DamageFormTypes.IGeneralInfoUpdate) => {
                    return axios.put("/masterdatadamage/damageform/updateform", generalInfo, { params: { tenant }});
                },
                closeByid: (id: string) => {
                    return axios.put(`/masterdatadamage/damageform/close/${id}`);
                },
                toBeCharged: (tenant: string, damageFormId: string) => {
                    return axios.put(`/masterdatadamage/damageform/tobecharged/${damageFormId}`, null, {params: {tenant}});
                },
                reopenByid: (tenant: string, formId: string) => {
                    return axios.put(`/masterdatadamage/damageform/reopen`, null,  {params: {tenant: tenant, formId: formId}});
                },
                changeRepo: (tenant: string, formId: number, repositoryId: number ) => {
                    return axios.put(`/masterdatadamage/damageform/updateform/repository`, null,  {params: {tenant: tenant, formId: formId, repositoryId: repositoryId}});
                }

            },
            attachments: {
                get: {
                    byId: (id: string) => {
                        return axios.get<DamageFormTypes.IAttachments[]>("/masterdatadamage/attachments/getbyform", {params: { damageIdForm: id }}).then(
                            (response) => {
                                return response.data
                            }
                        )
                    },
                    zipById: (id: string) => {
                        return axios.get("/masterdatadamage/attachments/getzipblob", {
                            params: {formId: id},
                            responseType: "arraybuffer",
                        });
                    },
                    blobById: (attachmentId: string, type: string | undefined) => {
                        return axios.get("/masterdatadamage/attachments/getblob", {
                            params: {attachmentId, type},
                            responseType: "arraybuffer",
                        });
                    },					
					blobByIdForGallery : (attachmentId: string, type: string | undefined) => {
						return axios.get<string>("/masterdatadamage/attachments/getblob", {
							params: {attachmentId, type},
							responseType: "arraybuffer",
						})
						.then(
							response =>  Buffer.from(response.data, 'binary').toString('base64'),
						);
					}
                },
                post: (data: DamageFormTypes.IAttachmentForm) => {
                    return axios.post("/masterdatadamage/attachments/addattachments", data.file, {
                        params: {
                            damageFormId: data.damageFormId,
                            attachmentTypeId: data.attachmentTypeId,
                            documentType: data.documentType,
                        }
                    });
                },
                delete: (tenant: string, idAttachment: string, type: string | undefined) => {
                    return axios.delete("/masterdatadamage/attachments/deleteattachment", {
                        params: { tenant, idAttachment, type }
                    });
                },
                update: (tenant: string, id: string, data: DamageFormTypes.IAttachmentForm) => {
                    const req = {
                        attachmentId: id,
                        documentType: data.documentType
                      }
                    return axios.put("/masterdatadamage/attachments/updatedoctype", req, {params: {tenant}});
                }
            },
            practice: {
                get: {
                    listById: (tenant: string, idDamageForm: string) => {
                        return axios.get<DamageFormTypes.IPractice[]>("/masterdatadamage/practice/byformid", {params: {tenant, idDamageForm}}).then(
                            response => {
                                return response.data;
                            }
                        )
                    },
                    byId: (tenant: string, practiceId: number) => {
                        return axios.get("/masterdatadamage/practice/byid", { 
                            params: { tenant, practiceId },
                            responseType: "arraybuffer",
                        });
                    }
                },
                post: {
                    create: (tenant: string, idDamageForm: string, practiceNumber: string, data: FormData) => {
                        return axios.post("/masterdatadamage/practice/add", data, {
                            params: {
                                tenant,
                                idDamageForm,
                                practiceNumber,
                            }
                        })
                    }
                },
                delete: (tenant: string, practiceId: string) => {
                    return axios.delete("/masterdatadamage/practice/delete", { params: {tenant, practiceId}});
                }
            }
        },
        task1: {
            get: {
                byId: (id: string, tenant: string) => {
                    return axios.get<DamageFormTypes.ITask1>("/masterdatadamage/task1/byformid", {params: {damageFormId: id, tenant: tenant}}).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            },
            put: {
                closeById: (id: string) => {
                    return axios.put<DamageFormTypes.ITask1>(`/masterdatadamage/task1/close/${id}`).then(
                        (response) => {
                            return response.data
                        }
                    )
                },
                reopenByid: (tenant: string, taskId: string) => {
                    return axios.put(`/masterdatadamage/task1/reopen`, null, {params: {tenant: tenant, taskId: taskId}});
                }
            }
        },
        task2: {
            get: {
                byId: (id: string, tenant: string) => {
                    return axios.get<DamageFormTypes.ITask2>("/masterdatadamage/task2/byformid", {params: {damageFormId: id, tenant: tenant}}).then(
                        (response) => {
                            //return response.data

                            let payload = {...response.data};
                            if(i18n.language.includes("it")) {
                                payload.cdwPlus = payload.cdwPlus && payload.cdwPlus.toString().includes(".") ? payload.cdwPlus.toString().replace(".", ",") : payload.cdwPlus;
                                payload.requestedAmount = payload.requestedAmount && payload.requestedAmount.toString().includes(".") ? payload.requestedAmount.toString().replace(".", ",") : payload.requestedAmount;
                                payload.redeemedAmount = payload.redeemedAmount && payload.redeemedAmount.toString().includes(".") ? payload.redeemedAmount.toString().replace(".", ",") : payload.redeemedAmount;
                                payload.lumpSumApproved = payload.lumpSumApproved && payload.lumpSumApproved.toString().includes(".") ? payload.lumpSumApproved.toString().replace(".", ",") : payload.lumpSumApproved;
                                payload.obtainedAmount = payload.obtainedAmount && payload.obtainedAmount.toString().includes(".") ? payload.obtainedAmount.toString().replace(".", ",") : payload.obtainedAmount;
                                
                            
                            }
                            return payload;
                        }
                    )
                }
            },
            post: {
                openById: (id: string) => {
                    return axios.post<DamageFormTypes.ITask2>(`/masterdatadamage/task2/open/${id}`).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            },
            put: {
                closeById: (id: string) => {
                    return axios.put<DamageFormTypes.ITask2>(`/masterdatadamage/task2/close/${id}`).then(
                        (response) => {
                            return response.data
                        }
                    )
                },
                reopenByid: (tenant: string, taskId: string) => {
                    return axios.put(`/masterdatadamage/task2/reopen`, null, {params: {tenant: tenant, taskId: taskId}});
                }
            }
        },
        task1Update: {
            put: {
                updateTask1: (data: DamageFormTypes.ITask1Update) => {
                    return axios.put("/masterdatadamage/task1/update", data).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            }
        },
        task2Update: {
            put: {
                updateTask2: (data: DamageFormTypes.ITask2Update) => {
                    return axios.put("/masterdatadamage/task2/update", data).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            }
        },
        task3: {
            get: {
                byId: (id: string, tenant: string) => {
                    return axios.get<DamageFormTypes.ITask3>("/masterdatadamage/task3/byformid", {params: {damageFormId: id, tenant: tenant}}).then(
                        (response) => {
                            let payload = {...response.data};
                            if(i18n.language.includes("it")) {
                                payload.clientCharge = payload.clientCharge && payload.clientCharge.toString().includes(".") ? payload.clientCharge.toString().replace(".", ",") : payload.clientCharge;
                                payload.invoiceAmount = payload.invoiceAmount && payload.invoiceAmount.toString().includes(".") ? payload.invoiceAmount.toString().replace(".", ",") : payload.invoiceAmount;
                                payload.quotePrice = payload.quotePrice && payload.quotePrice.toString().includes(".") ? payload.quotePrice.toString().replace(".", ",") : payload.quotePrice;
                                payload.gridAmount = payload.gridAmount && payload.gridAmount.toString().includes(".") ? payload.gridAmount.toString().replace(".", ",") : payload.gridAmount;
                                payload.missingDotationAmount = payload.missingDotationAmount && payload.missingDotationAmount.toString().includes(".") ? payload.missingDotationAmount.toString().replace(".", ",") : payload.missingDotationAmount;
                                payload.realInvoiceAmount = payload.realInvoiceAmount && payload.realInvoiceAmount.toString().includes(".") ? payload.realInvoiceAmount.toString().replace(".", ",") : payload.realInvoiceAmount;
                                payload.realMissEquipInvoiceAmount = payload.realMissEquipInvoiceAmount && payload.realMissEquipInvoiceAmount.toString().includes(".") ? payload.realMissEquipInvoiceAmount.toString().replace(".", ",") : payload.realMissEquipInvoiceAmount;
                                
                            
                            }
                            return payload;
                        }
                    )
                }
            },
            post: {
                openById: (id: string) => {
                    return axios.post<DamageFormTypes.ITask3>(`/masterdatadamage/task3/open/${id}`).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            },
            put: {
                closeById: (id: string) => {
                    return axios.put<DamageFormTypes.ITask3>(`/masterdatadamage/task3/close/${id}`).then(
                        (response) => {
                            return response.data
                        }
                    )
                },
                reopenByid: (tenant: string, taskId: string) => {
                    return axios.put(`/masterdatadamage/task3/reopen`, null, {params: {tenant: tenant, taskId: taskId}});
                }
            }
        },
        task3Update: {
            put: {
                updateTask3: (data: DamageFormTypes.ITask3Update, tenant: string) => {
                    return axios.put("/masterdatadamage/task3/update", data, {params: { tenant: tenant}}).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            }
        },
        get: {
            taskExist: (id:string, tenant: string) => {
                return axios.get<DamageFormTypes.ITaskExist>("/masterdatadamage/damageform/tasksexist", {params: {damageFormId: id, tenant: tenant}}).then(
                    (response) => {
                        return response.data
                    }
                )
            }
        },
        actions: {
            post: {
                addaction: (tenant: string, data: DamageFormTypes.IAddAction ) => {
                    return axios.post<DamageFormTypes.IAddAction>("/masterdatadamage/formaction/addaction", data, {params: {tenant: tenant}} ).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            },
            get: {
                byForm: (tenant: string, idDamageForm: number) => {
                    return axios.get<DamageFormTypes.IActions[]>("/masterdatadamage/formaction/getbyform", {params: {idDamageForm: idDamageForm, tenant: tenant}}).then(
                        (response) => {
                            return response.data
                        }
                    )
                }
            }
        }
    },
    create: {
        get: {
            proposalRa: (tenant: string, plate: string, accidentDate: string | undefined) => {
                return axios.get<CreateDamageFormTypes.IRentalAgreement>("/masterdatadamage/damageform/proposalra", {params: {tenant, plate, accidentDate}}).then(
                    response => response.data,
                )
            },
            partPosition: (tenant?: string) => {
                return axios.get<OperationTypes.VehiclePart[]>("/masterdatadamage/partposition/bytenant", { params: { tenant }}).then(
                    response => response.data,
                )
            },
            severity: () => {
                return axios.get<string[]>("/masterdatadamage/severity").then(
                    response => response.data,
                )
            },
            events: (tenant?: string, fromSearch: string = "", fromCrud: string = "") => {
                return axios.get<OperationTypes.Domain[]>("/masterdatadamage/event", {params: { tenant, fromSearch, fromCrud }}).then(
                    response => response.data,
                )
            },
            existingDamages: (tenant?: string, plate?: string) => {
                if (!plate) return Promise.resolve([]);

                return axios.get<OperationTypes.Damage[]>("/masterdatadamage/damage/getopen", {params: { tenant, plate }}).then(
                    response => response.data,
                )
            },
            existingNewDamages: (tenant?: string, plate?: string) => {
                if (!plate) return Promise.resolve([]);

                return axios.get<OperationTypes.Damage[]>("/masterdatadamage/damage/getopen/new", {params: { tenant, plate }}).then(
                    response => response.data,
                )
            },
            photos: (damageId: string) => {
                return axios.get<CreateDamageFormTypes.IRespPhotoList[]>(`/masterdatadamage/snapshot/bydamage/${damageId}`).then(
                    response => response.data,
                )
            },
            photoBlob: (snapshotId: string) => {
                return axios.get<string>(`/masterdatadamage/snapshot/getblob/${snapshotId}`,
                {
                    responseType: "arraybuffer",
                })
                .then(
                    response =>  Buffer.from(response.data, 'binary').toString('base64'),
                )
            }
        },
        post: {
            addOpen: (tenant: string, data: CreateDamageFormTypes.IReqCreateDamage) => {
                return axios.post<CreateDamageFormTypes.IRespCreateDamage[]>("/masterdatadamage/damage/addopen", data, { params: {tenant}}).then(
                    response => response.data,
                )
            },
            addPhoto: (damageId: number, snapshots: (File | null)[]) => {
                const data = new FormData();
                if (snapshots[0]) {
                    data.append("snapshots", snapshots[0]);
                }
                if (snapshots[1]){
                    data.append("snapshots", snapshots[1]);
                }

                return axios.post("/masterdatadamage/snapshot/add", data, {
                    params: {
                        damageId,
                        damageIsOpen: true,
                    },
                    headers: { "Content-Type": "multipart/form-data" },
                }).then(
                    response => response.data,
                )
            },
            addEvent: (tenant: string, data: CreateDamageFormTypes.IReqCreateEvent) => {
                return axios.post<CreateDamageFormTypes.IRespCreateEvent[]>("/masterdatadamage/damageform/addform", data, { params: { tenant }}).then(
                    response => response.data,
                )
            },
             assignDamage: (tenant: string | undefined, fromSC: boolean | undefined, data: CreateDamageFormTypes.IReqAssignDamage[]) => {
                return axios.put("/masterdatadamage/damageform/assigndamages", data, { params: {tenant, fromSC}}).then(
                    response => response.data                    
                )
            },
            confirmCreation: (tenant: string | undefined, formManagementSapId: string | undefined, data: CreateDamageFormTypes.IReqConfirmCreation) => {
                return axios.put<any>("/masterdatadamage/damageform/confirmform", {
                    ...data,
                    fromCrud: true,
                    formManagementSapId: formManagementSapId,
                }, {params: {tenant}})
                .then(
                    response => response.data
                )
            }
        },
        delete: {
            deleteForm: (damageFormId : number) => {
                return axios.delete(`/masterdatadamage/damageform/deleteform/${damageFormId}`)
            },
            deleteDamage: (damageId : number) => {
                return axios.delete(`/masterdatadamage/damage/deleteopen/${damageId}`)
            }
        }
    }
}


export default DamageFormService;
